import type { PageLoad } from './$types';

export const entries = async () => {
  return [{ lang: 'en' }, { lang: 'th' }];
};

export const load: PageLoad = async ({ params }) => {
  return {
    lang: params.lang || 'en'
  };
};
